import { gsap } from "gsap";

export default function() {
  const logo = gsap.timeline({ ease: "bounce.out" });

  logo.to(".js-fva-logo", {
    delay: 5.35,
    duration: 0.25,
    rotation: 8
  });

  logo.to(".js-fva-logo", {
    duration: 0.2,
    rotation: -7
  });

  logo.to(".js-fva-logo", {
    duration: 0.15,
    rotation: 5
  });

  logo.to(".js-fva-logo", {
    duration: 0.1,
    rotation: -3
  });

  logo.to(".js-fva-logo", {
    duration: 0.1,
    rotation: 0
  });
}
